export enum UserStatusEnum {
  None = 0,
  PendingCompanyRegistration = 1,
  PendingPhoneNumberConfirmation = 2,
  Active = 3
}

export interface CountryDto {
  id: string;
  name: string;
  code2: string;
  code3: string;
  phoneCode: string;
}

export interface IndustryDto {
  id: string;
  name: string;
  description: string;
}

export interface SendConfirmationEmailDto {
  email: string;
}

export interface CreateAccount extends AccountData, AccountCredentialsData {}

export interface AccountData {
  email: string;
  privacyPolicy: boolean;
  termsOfUsage: boolean;
  firstName: string;
  lastName: string;
}

export interface AccountCredentialsData {
  password: string;
  confirmPassword: string;
  temporaryPassword: string;
}

export interface RegisterCompany {
  countryId: string;
  isInternationalHolding: boolean;
  companyBusinessCode: string;
  industryId: string;
  numberOfPeople: number;
  phoneNumber: string;
  companyName: string;
  countryCodeId: string;
}

export interface ConfirmPhoneNumberDto {
  phoneNumber: string;
  otpCode: string;
}
